import React from 'react';

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSection from "../../molecules/title-section";
import GreenCard from '../../molecules/green-card/greenCard';

// Styles //
import "./interestSection.scss";

const InterestSection = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        referenciaPlantillaContenido: refPlantilla,
    } = props;

    const onSaveTheme = (title: string) => {
        localStorage.setItem("theme", title);
    }
    
    return (
        <div className="o-interest-section">
            <div className="container">
                <TitleSection title={tituloGeneral}/>
                <div className="o-interest-section__container">
                    {refPlantilla.map((item, index) => (
                        <GreenCard
                            key={index}
                            title={item.tituloBanner}
                            imageSrc={item.imagenPrincipal[0].file.url}
                            link={item.redireccionBoton}
                            onClick={() => onSaveTheme(item.tituloBanner)}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default InterestSection;